<div class="endline-container" [ngClass]="{'no-header': !showAppHeader}">
  <div class="content">
    <app-display-screen class="display-screen"></app-display-screen>
  </div>
</div>